import type { GroupIds } from "@/shared/group-configs/group-ids";

/** Deployment admission is independent of workflow support and experiment assignment. */
export type GptLiveV3LineAdmission = Readonly<{
  groupId: GroupIds;
  calledNumber: string;
  allowProduction: boolean;
}>;

/** Voice runtimes used by runtime selection, experiments, and telemetry. */
export enum VoiceAgentRuntime {
  GptLive = "gpt_live",
  Legacy = "legacy",
  SlowThinker = "slow_thinker",
}

/** Voice workflows shared by runtime contracts, group configuration, and eval catalogs. */
export enum GroupWorkflow {
  Cancel = "cancel",
  Confirm = "confirm",
  Faq = "faq",
  LeaveMessage = "leave_message",
  PrescriptionRefill = "prescription_refill",
  Reschedule = "reschedule",
  Schedule = "schedule",
  ScheduleFollowUp = "schedule_follow_up",
  ScheduleInitial = "schedule_initial",
  TestResults = "test_results",
  WrapUp = "wrap_up",
}

/** Bounded Slow Thinker runtime failures persisted in traces and transfer audit metadata. */
export enum SlowThinkerRuntimeFailureType {
  RepeatedWorkflowCommand = "repeated_workflow_command",
  SpeechPlaybackDidNotStart = "speech_playback_did_not_start",
  TtsError = "tts_error",
  Unknown = "unknown",
}

/** Whether a fail-closed workflow handoff came from a negative policy verdict or missing policy evidence. */
export enum WorkflowPolicyDecision {
  Blocked = "blocked",
  Unavailable = "unavailable",
}
